var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-slick/~/can-use-dom/index.js
 ** module id = 1095
 ** module chunks = 0
 **/